import React, { Component } from 'react'
import { connect } from 'react-redux';
import Axios from 'axios'
import PageNo from "../common/PageNo";
import logo from "./logo.png";
const userSession = localStorage.getItem("userSession");
const data = userSession ? JSON.parse(userSession) : {};

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CartecHeader extends Component {
    state = {
      words: {},
      lang: "gb",
    };
    async componentDidMount() {
      this.getLang();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.lang !== prevState.lang) {
        return { lang: nextProps.lang };
      } else return null;
    }
    getLang = () => {
      const base_url = window.location.origin;
      Axios.get(`${base_url}/lang.json`).then((res) => {
        let lang = localStorage.getItem("lang");
        this.setState({ lang: lang });
        this.setState({ words: res.data });
      });
    }
    lang = (word) => {
      const { lang, words } = this.state;
      return words[word] ? words[word][lang] : word;
    };
    render() {
        return (
          <>
          <div className="row pdfHeader" style={{padding:0, border:1}}>
            <div className="container-fluid p-0 top-header-pdf">
              <div className="row p-0">
                <div className="col-lg-1 col-md-1 col-sm-12 p-0">
                  <p style={{background:"#D81808",}}></p>
                  <p style={{background:"#000000",}}></p>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 p-0" style={{textAlign: "center"}}>
                    <img src={logo} alt="logo" />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 p-0">
                  <p style={{background:"#D81808",height:"100%", alignItems:"center", display:"grid"}}>{this.lang("Vehicle Scan Report")}</p>
                  {/* {this.state.data !== "" ? <p> Date: {this.state.data.split("_")[2]+"-"+this.state.data.split("_")[1]+"-"+this.state.data.split("_")[0]+" "+this.state.data.split("_")[3]+":"+this.state.data.split("_")[4]}
                  </p> : null} */}
                  {/* <p style={{background:"#D81808",}}></p> */}
                </div>
              </div>
            </div>
          </div>
            </>
        )
    }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CartecHeader);
